module.exports = "../dist/img/mini-20.5d98.jpg";